import { useEffect, useState } from 'react';
import { api } from '../api.js';
import Icon from '../components/Icon.js';

const VOICES = ['Kore', 'Aoede', 'Charon', 'Fenrir', 'Leda', 'Orus', 'Puck', 'Zephyr'];

export default function Settings() {
  const [text, setText] = useState('');
  const [voice, setVoice] = useState('Kore');
  const [greetBusy, setGreetBusy] = useState(false);

  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [passBusy, setPassBusy] = useState(false);

  const [err, setErr] = useState('');
  const [note, setNote] = useState('');

  useEffect(() => {
    api.inboundGreeting().then((g) => { setText(g.text ?? ''); setVoice(g.voice); })
      .catch((e) => setErr(e.message));
  }, []);

  async function saveGreeting(e: React.FormEvent) {
    e.preventDefault();
    setGreetBusy(true); setErr(''); setNote('');
    try {
      const r = await api.saveInboundGreeting(text, voice);
      setNote(`Message regenerated: ${(r.durationMs / 1000).toFixed(1)}s${r.cached ? ' (from cache)' : ''}.`);
    } catch (e) { setErr(e instanceof Error ? e.message : 'error'); }
    finally { setGreetBusy(false); }
  }

  async function savePassword(e: React.FormEvent) {
    e.preventDefault();
    if (next !== confirm) { setErr('The new passwords do not match.'); return; }
    setPassBusy(true); setErr(''); setNote('');
    try {
      await api.changePassword(current, next);
      setNote('The password has been changed.');
      setCurrent(''); setNext(''); setConfirm('');
    } catch (e) { setErr(e instanceof Error ? e.message : 'error'); }
    finally { setPassBusy(false); }
  }

  return (
    <>
      <h1>Settings</h1>
      <p className="subtitle">The message for inbound calls and your own account.</p>

      {err && <div className="err">{err}</div>}
      {note && <div className="card" style={{ marginBottom: 14, padding: '9px 12px' }}>{note}</div>}

      <h2>Message for inbound calls</h2>
      <div className="card" style={{ maxWidth: 720 }}>
        <p className="muted" style={{ marginTop: 0, fontSize: 12.5 }}>
          Our numbers appear in the call logs of people who do not know us, and some of
          them call back. This is what they hear. It is played in English, regardless of
          the campaign the call originally came from.
        </p>
        <form onSubmit={saveGreeting}>
          <label><span>Text (English)</span>
            <textarea value={text} onChange={(e) => setText(e.target.value)} rows={3} /></label>
          <div className="row">
            <label style={{ margin: 0, width: 180 }}><span>Voice</span>
              <select value={voice} onChange={(e) => setVoice(e.target.value)}>
                {VOICES.map((v) => <option key={v}>{v}</option>)}
              </select></label>
            <button className="primary" disabled={greetBusy || !text.trim()}>
              <Icon name="sound" />{greetBusy ? 'Generating…' : 'Regenerate'}
            </button>
          </div>
        </form>
        <p className="muted" style={{ fontSize: 12, marginBottom: 0 }}>
          Do not put a company name in it: a name in the message invites questions and
          complaints from people who have no use for the information anyway.
        </p>
      </div>

      <h2>Change password</h2>
      <form onSubmit={savePassword} className="card" style={{ maxWidth: 420 }}>
        <label><span>Current password</span>
          <input type="password" value={current} autoComplete="current-password"
                 onChange={(e) => setCurrent(e.target.value)} /></label>
        <label><span>New password (at least 8 characters)</span>
          <input type="password" value={next} autoComplete="new-password"
                 onChange={(e) => setNext(e.target.value)} /></label>
        <label><span>Confirm the new password</span>
          <input type="password" value={confirm} autoComplete="new-password"
                 onChange={(e) => setConfirm(e.target.value)} /></label>
        <button className="primary" disabled={passBusy || !current || next.length < 8}>
          {passBusy ? 'Saving…' : 'Change password'}
        </button>
      </form>
    </>
  );
}
